var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed"},[_c('svg-icon',{staticClass:"icon",attrs:{"name":"top"},on:{"click":_vm.backTop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }